export default __webpack_public_path__ + "static/media/Photo 4 - BR - Maison créole.f3487930.png";